import React from 'react';
import {
  useMap,
  AdvancedMarker,
} from '@vis.gl/react-google-maps';
import styles from './CashBids.module.css';
import {ReactComponent as WheatIcon} from '../../../assets/images/wheat_icon.svg';
import {ReactComponent as WheatIconRed} from '../../../assets/images/wheat_icon_red.svg';
import {MarkerClusterer} from '@googlemaps/markerclusterer';
import {
  CTable,
  CCard,
  CTableHead,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CCardHeader,
  CCardBody,
  CTableRow,
} from '@coreui/react-pro';
import {
  userSelectedCashBidLocation,
  showCashBidModal,
  showPurchaseContractModal,
} from './cashBids-actions';
import {useDispatch} from 'react-redux';

const CashBidsMarkers = ({locations, zoom}) => {

  const dispatch = useDispatch();

  const map = useMap();

  const [markers, setMarkers] = React.useState({});
  
  const clusterer = React.useRef(null);

  React.useEffect(() => {
    if (!map) {
      return;
    }
    if (!clusterer.current) {
      clusterer.current = new MarkerClusterer({
        map: map,
      });
    }
  }, [map]);

  React.useEffect(() => {
    clusterer.current?.clearMarkers();
    clusterer.current?.addMarkers(Object.values(markers));
  }, [markers]);

  const setMarkerRef = (marker, key) => {
    if (marker && markers[key]) {
      return;
    }
    if (!marker && !markers[key]) {
      return;
    }
    setMarkers(prev => {
      if (marker) {
        return {...prev, [key]: marker};
      } 
      else {
        const newMarkers = {...prev};
        delete newMarkers[key];
        return newMarkers;
      }
    });
  };

  const calcScoreboardColumns = (length) => {
    return Math.ceil(length / 2);
  }

  return (
    <>
      {
        locations.map((location, index) => (
          <AdvancedMarker
            position={{
              lng: location.longitude,
              lat: location.latitude
            }}
            key={location.locationId + index.toString()}
            ref={(marker) => setMarkerRef(marker, location.locationId + index.toString())}
            onClick={() => {
              dispatch(userSelectedCashBidLocation(location, true));
              dispatch(showCashBidModal());
            }}>
            {
              zoom <= 10 ? (
                <button 
                  className={location.company === 'Premier Cooperative - IL' ? styles.cashbidsMarkerBtn : styles.cashbidsMarkerBtnCompetitor}
                  onClick={() => {
                    dispatch(userSelectedCashBidLocation(location));
                    dispatch(showCashBidModal());
                  }}>
                  <div className={styles.cashbidsMarkerArrow}></div>
                  {
                    location.company === 'Premier Cooperative - IL' ? (
                      <WheatIcon className={styles.cashbidsMarkerIcon} />
                    ) : (
                      <WheatIconRed className={styles.cashbidsMarkerIcon} />
                    )
                  }
                </button>
              ) : zoom > 10 && zoom <= 12 ? (
                <div 
                  className={location.company === 'Premier Cooperative - IL' ? styles.cashbidsMarkerBtnLarge : styles.cashbidsMarkerBtnLargeCompetitor} 
                  onClick={() => {
                    dispatch(userSelectedCashBidLocation(location));
                    dispatch(showCashBidModal());
                  }}>
                    <div className={styles.locationName}>{location.locationName}</div>
                    <div className={styles.locationBr}></div>
                    {
                      location.bids.map((bid, index) => (
                        index <= 3 ? ( 
                          <div key={index} className={styles.scoreboardDiv}>
                            <div className={styles.commodityDiv}>
                              <div>{bid.commodity}</div>
                              <div>${bid.bids[0]?.cashprice}</div>
                            </div>
                            {
                              location.company === 'Premier Cooperative - IL' ? (
                                <div className={styles.sellGrainButtonDiv}>
                                  <button 
                                    className={styles.sellGrainButton}
                                    onClick={(e) => {
                                      dispatch(showPurchaseContractModal(bid.bids[0], location, bid.bids[0].futures, false));
                                      e.stopPropagation();
                                    }}>
                                    Sell Grain
                                  </button>
                                </div>
                              ) : null
                            }
                          </div>
                        ) : <div key={index}>...</div>
                      ))
                    }
                    <div className={styles.cashbidsMarkerArrow}></div>
                </div>
              ) : (
                <div
                  className={location.company === 'Premier Cooperative - IL' ? styles.cashbidsScoreboard : styles.cashbidsScoreboardCompetitor} 
                  onClick={() => {
                    dispatch(userSelectedCashBidLocation(location));
                    dispatch(showCashBidModal());
                  }}>
                  <div className={styles.csTitle}>{location.locationName}</div>
                  <div 
                    className={styles.csGrid} 
                    style={{ 
                      gridTemplateColumns: `repeat( ${calcScoreboardColumns(location.bids.length)}, 260px)`, 
                      gridTemplateRows: `repeat(${location.bids.length === 1 ? 1 : 2}, 100px)`,
                    }}>
                    {
                      location.bids.map((bid, index) => (
                        <CCard key={index} className={styles.csCard}>
                          <CCardHeader className={styles.csHeader}>{bid.commodity}</CCardHeader>
                          <CCardBody style={{padding: 0,}}>
                            <CTable>
                              <CTableHead style={{ textAlign: 'left' }}>
                                <CTableRow>
                                  <CTableHeaderCell>Del. End</CTableHeaderCell>
                                  <CTableHeaderCell>Price</CTableHeaderCell>
                                  <CTableHeaderCell>Basis</CTableHeaderCell>
                                  <CTableHeaderCell></CTableHeaderCell>
                                </CTableRow>
                              </CTableHead>
                              <CTableBody style={{ textAlign: 'left' }}>
                                <CTableRow>
                                  <CTableDataCell>{new Date(bid.bids[0].delivery_end).toLocaleDateString()}</CTableDataCell>
                                  <CTableDataCell>${bid.bids[0].cashprice}</CTableDataCell>
                                  <CTableDataCell>{bid.bids[0].basis / 100}</CTableDataCell>
                                  {
                                    location.company === 'Premier Cooperative - IL' ?  (
                                      <CTableDataCell>
                                        <button 
                                          className={styles.sellGrainButton}
                                          onClick={(e) => {
                                            dispatch(showPurchaseContractModal(bid.bids[0], location, bid.bids[0].futures, false));
                                            e.stopPropagation();
                                          }}>
                                          Sell Grain
                                        </button>
                                      </CTableDataCell>
                                    ) : null
                                  }
                                </CTableRow>
                              </CTableBody>
                            </CTable>
                          </CCardBody>
                        </CCard>
                      ))
                    }
                  </div>
                  <div className={styles.csMarkerArrow} />
                </div>
              )
            }
          </AdvancedMarker>
        ))
      }
    </>
  );
};

export default CashBidsMarkers;
